import { Deserializable } from '../deserializable';


export  class DonViNgoai implements Deserializable
{
  public  id: number;
  public  tenCQ: string;
  public  tenVietTat: string;
  public  cap: number;
  public  maCapTren: number;
  public  ngayThanhLap: string;
  public  diaChi: string;
  public  dienThoai: string;
  public  soFax: string;
  public  email: string;
  public  diaChiWeb: string;
  public  maLinhVucHoatDong: number;
  public  maNhomDoiTac: number;
  public  lichSuQuanHe: string;
  public  ngayBatDauHopTac: string;
  public  hienThi: number;
  public  stt: number;
  public  suDung: number;
  public  hasChild: boolean;
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
